var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBracketRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.904 480C121.841 480 115.685 478.25 110.248 474.625C105.748 471.625 0 399.471 0 256.005S105.748 40.385 110.248 37.385C124.966 27.573 144.81 31.542 154.622 46.26C164.403 60.916 160.466 80.728 145.872 90.54C142.372 92.947 63.999 147.758 63.999 256.005C63.999 364.378 142.528 419.189 145.872 421.47C160.434 431.376 164.309 451.251 154.466 465.844C148.278 475.031 138.185 480 127.904 480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracketRound);
export default __webpack_public_path__ + "static/media/bracket-round.ba98a9fc346e604b1feb8a801066f723.svg";
export { ForwardRef as ReactComponent };